import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const QUOTE_ID = 'Rl9nsP94Hnf1Qw';

const Accordion = ({ title, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);

        if (next && onOpen) {
            onOpen(title);
        }
    };
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={handleToggle}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

function Quote_Rl9nsP94Hnf1Qw() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [unlocked, setUnlocked] = useState(false);
    const [error, setError] = useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        fetch(`/api/quoteRoute/${QUOTE_ID}`)
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false, meta = {}) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                unlockMethod: meta.method,
                unlockValue: meta.value
            })
        }).catch(() => { });
    };

    const trackAccordionOpen = (sectionTitle) => {
        if (suppressNotifications) return;
        fetch('/api/quoteRoute/interaction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                type: 'accordion_open',
                section: sectionTitle
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                                const phone1 = normalize(quoteData?.clientPhone);
                                const phone2 = normalize(quoteData?.clientPhone2);
                                const password = normalize(quoteData?.customPassword);

                                if (cleaned === '1131') {
                                    unlock(true, { method: 'override', value: cleaned });
                                } else if (cleaned === phone1) {
                                    unlock(false, { method: 'clientPhone', value: cleaned });
                                } else if (cleaned === phone2) {
                                    unlock(false, { method: 'clientPhone2', value: cleaned });
                                } else if (cleaned === password) {
                                    unlock(false, { method: 'customPassword', value: cleaned });
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                            const phone1 = normalize(quoteData?.clientPhone);
                            const phone2 = normalize(quoteData?.clientPhone2);
                            const password = normalize(quoteData?.customPassword);

                            if (cleaned === '1131') {
                                unlock(true, { method: 'override', value: cleaned });
                            } else if (cleaned === phone1) {
                                unlock(false, { method: 'clientPhone', value: cleaned });
                            } else if (cleaned === phone2) {
                                unlock(false, { method: 'clientPhone2', value: cleaned });
                            } else if (cleaned === password) {
                                unlock(false, { method: 'customPassword', value: cleaned });
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>

                        <Accordion title='Option 1: Premium Site Restoration' onOpen={trackAccordionOpen}>
                            <div className="quote-section">

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Objective</h3>
                                    <div className="project-description">
                                        <strong>The objective of this project is to reclaim the area currently occupied by the water feature and integrate it seamlessly into the surrounding lawn. This involves the removal of organic mulch, the systematic deconstruction of the earthen berm, structural backfilling of the pond cavity, and the installation of fresh sod across the approximately 350 sqft footprint. This quote includes specialized low-impact machinery and ground protection to ensure the logistics of moving over 10,000 lbs of material from your driveway to the back yard does not damage your existing landscape or turf.</strong>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Logistics & Turf Protection:</strong> Establish a "temporary roadway" using ~20 sheets of ground-protection plating. This prevents soil compaction and rutting of your side-yard during the heavy transport phase.</li>
                                            <li><strong>Mulch removal & site-prep:</strong> Rake and load all mulch covering the planting bed and berm area for off-site disposal. Two landscape lights in this area will be flagged and worked around carefully.</li>
                                            <li><strong>Berm excavation & backfill:</strong> Break down the existing soil berm and redistribute it into the pond void. The area near the tree will be worked by hand to protect the tree's primary feeder root system from mechanical damage. Material will be installed and compacted in 6-inch "lifts" (layers) to ensure a solid sub-grade and prevent future settlement or dipping.</li>
                                            <strong>Note:</strong> The displaced berm soil will not completely fill the void. Supplemental fill dirt will address any remaining deficit.
                                            <li><strong>Precision Grading & Topsoil:</strong> Import and spread 1.5 yards of clean fill to reach sub-grade. Follow with 2 yards of screened topsoil across the full ~350 sq ft area to create a nutrient-rich root zone and a seamless transition between the new sod, adjacent pavers, and existing lawn.</li>
                                            <li><strong>Sod Installation:</strong> Install approximately 350 sqft of fresh sod (matched to existing species). Sod will be laid in a staggered joint pattern with edges hand-trimmed for a clean, established transition into the old grass.</li>
                                            <li><strong>Post-Care:</strong> Deep water the installation area immediately upon completion to "set" the roots.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 2 days. Day 1: Site prep, logistics, and bulk earthmoving. Day 2: Final grade, sod installation, and site restoration.</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li><strong>Specialized Equipment Rental (Dump Trailer & Tracked Buggy):</strong> $450</li>
                                            <li><strong>Turf Protection (Ground Shielding):</strong> Free (see note below)</li>
                                            <li><strong>Supplemental Fill Dirt (1.5 yards):</strong> $60</li>
                                            <li><strong>Screened Topsoil (2 Yards):</strong> $110</li>
                                            <li><strong>Sod (1 Full Pallet):</strong> $180</li>
                                            <li><strong>Mulch Disposal @ Recycle Center:</strong> $50</li>
                                            <li><strong>Misc Consumables (sod staples, mason line, etc.):</strong> $25</li>
                                            <li><strong>Procurement & Delivery:</strong> $150</li>
                                        </ul>
                                    </div>
                                    <div className="material-note"><strong>Custom note:</strong> I did the math and my previous guess of 1 yard of fill dirt will not be enough. Also, I will cover the cost of the ground shielding. I will be able to use that again on future projects so I consider it to be a company asset.<p>Materials and rental equipment are billed at exact cost and a copy of all receipts will be provided.</p><strong>Procurement & Delivery</strong> covers the professional selection of quality materials, time spent at suppliers, fuel, and the logistics of transporting 10,000+ pounds of materials to the job site.</div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor (flat rate):</span>
                                            <span className="pricing-value">$975</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials estimate:</span>
                                            <span className="pricing-value">~$1,025</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total:</span>
                                            <span className="pricing-value">$2,000</span>
                                        </div>
                                    </div>
                                    <div className="pricing-note">
                                        <p><strong>Custom note:</strong> This estimate assumes the pond liner, pump, and all stones/boulders have been fully removed from the site prior to my arrival.</p>
                                    </div>
                                </div>

                            </div>
                        </Accordion>

                        <Accordion title='Option 2: Standard Landscape Reclamation' onOpen={trackAccordionOpen}>
                            <div className="quote-section">
                                <div className='quote-subsection'>
                                    <h3 className="section-label">Objective</h3>
                                    <div className="project-description">
                                        <strong>The objective of this project is to reclaim the area currently occupied by the water feature and integrate it seamlessly into the surrounding lawn. This involves the manual removal of organic mulch, the deconstruction of the earthen berm, structural backfilling of the pond cavity, and the installation of fresh sod across the approximately 350 sqft footprint. This "efficiency-focused" quote is designed to minimize costs by utilizing a compact track loader in lieu of specialized equipment.</strong>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Low-Impact Mechanical Logistics:</strong> All materials will be transported from the staging area to the backyard via a tracked mini-loader. To minimize impact on your lawn, I will alternate between the two available side-paths to distribute foot traffic and prevent deep rutting.</li>
                                            <li><strong>Mulch removal & site-prep:</strong> Rake and extract all mulch covering the planting bed and berm area for off-site disposal. Landscape lighting will be flagged and protected.</li>
                                            <li><strong>Berm excavation & backfill:</strong> Deconstruct the existing soil berm and redistribute it into the pond void. Area near the tree will be worked exclusively by hand to protect the root system. Material will be compacted in 6-inch "lifts" to prevent future settlement.</li>
                                            <li><strong>Precision Grading:</strong> Import 1.5 yards of clean fill to reach sub-grade. The area will be hand-raked to match the elevation of the existing lawn and adjacent pavers.</li>
                                            <li><strong>Soil Amendment (Budget Option):</strong> Utilize high-quality bagged organic soil amendments (topsoil/compost blend) specifically in the reclaimed pond area to ensure a healthy root zone for new sod.</li>
                                            <li><strong>Sod Installation:</strong> Install approximately 350 sqft of fresh sod. Slabs will be laid in a staggered pattern with edges hand-trimmed for a clean transition.</li>
                                            <li><strong>Post-Care:</strong> Immediate deep watering to set the roots.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 2 days. Work includes material procurement, labor, and disposal of old mulch.</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li><strong>Equipment Rental (Tracked Mini-Loader):</strong> $280</li>
                                            <li><strong>Supplemental Fill Dirt (1.5 yards):</strong> $60</li>
                                            <li><strong>Sod (1 Full Pallet):</strong> $180</li>
                                            <li><strong>Soil Amendments (Targeted Bagged Soil):</strong> $70</li>
                                            <li><strong>Mulch Disposal & Recycle Fees:</strong> $50</li>
                                            <li><strong>Misc Consumables (sod staples, etc.):</strong> $25</li>
                                            <li><strong>Procurement & Delivery Fee:</strong> $150</li>
                                        </ul>
                                    </div>
                                    <div className="material-note">
                                        <p><strong>Grass Condition Note:</strong> While I will alternate paths and take every precaution to protect your lawn, please be aware that moving thousands of pounds of material involves high-intensity traffic. This may result in temporary flattening or minor wear on the side-yard grass. This typically recovers quickly with standard watering and mowing.</p>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor (Flat Rate):</span>
                                            <span className="pricing-value">$715</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials & Logistics:</span>
                                            <span className="pricing-value">~$815</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total:</span>
                                            <span className="pricing-value">$1,530</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a material order above $500, a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}

export default Quote_Rl9nsP94Hnf1Qw;
